<template>
    <div class="header">
        <div class="header_left">
            <a id="closeOrGoBack" @click="isLink">
                <img :src="imgLeft" v-if="!ac" />
                <img :src="createAcSrc(imgLeft)" v-if="ac" />
            </a>
        </div>
        <div class="header_right">
            <a v-if="progression"><img src="../assets/images/ic-status-loading-ac.svg" alt="Status" title="Status" @click="acMenu = !acMenu" /></a>
            <a><img :src="imgRight" alt="Acessibilidade" title="Acessibilidade" v-if="!ac" @click="acMenu = !acMenu" /></a>
            <a ><img :src="createAcSrc(imgRight)" alt="Acessibilidade" title="Acessibilidade" v-if="ac" @click="acMenu = !acMenu" /></a>
            <div class="header_access" v-show="acMenu">
                <ul class="header_access-list">
                    <li>
                        <a @click="accessAction('pounds')">
                            <img src="../assets/images/ic-acessibilidade-libras.svg">
                        </a>
                    </li>
                    <li>
                        <a @click="accessAction('contrast')">
                            <img src="../assets/images/ic-acessibilidade-contraste.svg">
                        </a>
                    </li>
                    <li>
                        <a @click="accessAction('increase')">
                            <img src="../assets/images/ic-acessibilidade-aumentar-texto.svg">
                        </a>
                    </li>
                    <li>
                        <a @click="accessAction('decrease')">
                            <img src="../assets/images/ic-acessibilidade-diminuir-texto.svg">
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapState } from 'vuex';
    import { goToRoute, goToLastRoute } from '../router/index';

    export default {
        name: "HeaderComponent",
        props: {
            next: {
                default: false
            },
            backRoute: {
                default: false
            },
            isSoon: {
                default: false
            },
            isNotFound: {
                default: false
            },
            progression: {
                default: true
            },
            imgLeft: {
                default: '/trocachip/img/logo.png'
            },
            imgRight: {
                default: '/trocachip/img/access.png'
            }
        },
        data() {
            return {
                acMenu: false
            }
        },
        computed:  mapState({
            ac: state => state.ac,
            font: state => state.font
        }),
        methods: {
            getLeftImgSrc() {
                return this.imgLeft;
            },
            createAcSrc(url) {
                return url.replace(/\.(\w+)$/, (a, b) => `-ac.${b}`);
            },
            isLink() {
                if(this.next) return this.$router.push(this.next);
                if(typeof this.backRoute == "string") {
                    return goToRoute(this.backRoute);
                }
                if(this.backRoute) return goToLastRoute();
                if(this.isSoon) return ''
                if(this.isNotFound) return this.$router.go(-2)
                if(!this.isNotFound && !this.isSoon) return this.$router.go(-1)
            },
            async accessAction(param) {
                let font = this.font;
                switch (param) {
                    case "contrast":
                        return this.$store.dispatch('contrast');
                    case "decrease":
                        if(font > 12) font--
                        document.body.style.fontSize = font + 'px'
                        return this.$store.dispatch('font', font);
                    case "increase":
                        if(font < 20) font++
                        document.body.style.fontSize = font + 'px'
                        return this.$store.dispatch('font', font);
                    case "pounds":
                        return this.$store.dispatch('pounds');
                    default:
                        break;
                }
            }
        }
    }
</script>

<style lang="scss">
    .header {
        width: 100%;
        height: 30px;
        top: 32px;
        padding: 0 23px;
        box-sizing: border-box;
        position: absolute;
        display: grid;
        grid-template-columns: 50% 50%;
        align-content: center;
        align-items: center;
        z-index: 1002;
        > .header_right {
            width: 100%;
            height: auto;
            > a {
                float: right;
                display: block;
                margin: 0 8px;
                > img {
                    width: 24px;
                    height: 24px;
                }
            }
            > .header_access {
                width: 158px;
                height: 53px;
                display: block;
                position: absolute;
                top: 26px;
                right: 58px;
                background: url("../assets/images/acessibilidade-popover.svg") no-repeat transparent;
                background-size: 100%;
                z-index: 1003;
                > .header_access-list {
                    list-style: none;
                    padding: 0;
                    margin: 20px 13px;
                    display: grid;
                    grid-template-columns: 25% 25% 25% 25%;
                    > li {
                        float: left;
                        text-align: center;
                        > a {
                            > img {
                                width: 24px;
                                height: 24px;
                            }
                        }
                    }
                }
            }
        }
    }
    @media (min-width: 768px) {
        .header {
            width: 90%;
            margin-left: 5%;
        }
    }
</style>
